import { useState, useEffect } from "react";

import AgendaPreview from "../../../components/Engage/AgendaPreview";
import Loading from "../../../components/Shared/Loading";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

export default function AgendaPreviewIndex() {
  const isMounted = useMounted();
  //   const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen overflow-y-auto bg-white flex flex-col items-center">
      {isMounted ? (
        <>
          {/* <div className="flex flex-col w-0 flex-1 overflow-hidden">
            <main className="flex-1 relative overflow-y-auto focus:outline-none"> */}
          <AgendaPreview />
          {/* </main>
          </div> */}
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}
